<template>
	<div>
		<div class="banner">
			<div class="title">能源管理系统</div>
			<div class="desc">
				对企业和园区边界内的水、电、燃气、热力进行分项计量，<br />提供集抄表、收费、账单、能耗统计、限额管理、故障告警、需量预警等于一体的能源管理服务。
			</div>
		</div>
		<div class="bg_gray">
			<div class="common_block_title">
				<div class="cn">能源管理 产品报价</div>
				<div class="en">Product quotation</div>
			</div>
		</div>
		<div class="energy-price">
			<div class="whole-table">
				<div class="table-row flex mt10 mb10">
					<div class="row-one ft16 bold mr3 w200">
						<span class="circular"></span>
						类别
						<el-icon
							class="drrowRight"
							:class="[allOpen ? 'upIcon' : '']"
							@click="allCheck"
							><DArrowRight
						/></el-icon>
					</div>
					<div class="flex rightTitle">
						<div class="row-one ft16 bold mr3 w160">
							<span class="circular"></span>
							功能
						</div>
						<div class="row-three ft16 bold mr3 w400">
							<span class="circular"></span>
							私有部署版
						</div>
						<div class="row-three ft16 bold mr3 w400">
							<span class="circular"></span>
							SaaS版
						</div>
					</div>
				</div>
				<div
					class="table-row flex mb3 flexw mb3"
					v-for="(item, i) in tableData"
					:key="item.title"
				>
					<div
						class="row-one ft16 bgcf bold mr3 leftTitle w200"
						v-if="item.isOpen"
					>
						<p
							class="title-text"
							:style="{ 'border-left-color': item.borCol }"
							@click="toggleHide(item)"
						>
							{{ item.title }}
							<span
								style="color: #0388fc; margin-left: 3px"
								v-if="item.titleIcon"
							>
								{{ item.titleIcon }}</span
							>
							<el-icon v-if="i > 2" class="drrowRight upIcon"
								><DArrowRight
							/></el-icon>
						</p>
					</div>
					<div class="wAll" v-if="item.isOpen">
						<div
							class="row-two ft14 flex"
							v-for="item1 in item.children"
							:key="item1.one"
						>
							<div class="row-one bgcf mr3 w160">
								<p>
									{{ item1.one }}
									<span
										style="color: #0388fc"
										v-if="item1.icon"
										>{{ item1.icon }}</span
									>
								</p>
								<p v-if="item1.oneTitle">
									{{ item1.oneTitle }}
								</p>
							</div>
							<div class="row-one bgcf mr3 w400">
								<p>{{ item1.two }}</p>
								<p v-if="item1.twoText">{{ item1.twoText }}</p>
								<el-icon v-if="item1.twoIcon === 'd'"
									><Check
								/></el-icon>
								<el-icon v-if="item1.twoIcon === 'c'"
									><Close
								/></el-icon>
							</div>
							<div
								class="row-one bgcf mr3 w400"
								v-if="!item1.custStyle"
							>
								<p>{{ item1.three }}</p>
								<p v-if="item1.threeText">
									{{ item1.threeText }}
								</p>
								<el-icon v-if="item1.threeIcon === 'd'"
									><Check
								/></el-icon>
								<el-icon v-if="item1.threeIcon === 'c'"
									><Close
								/></el-icon>
							</div>
						</div>
					</div>
					<div v-if="!item.isOpen" class="hideClass">
						<p @click="toggleHide(item)">
							{{ item.title }}
							<el-icon class="drrowRight"
								><DArrowRight
							/></el-icon>
						</p>
					</div>
				</div>
				<div class="explain bold" style="margin-top: 20px">说明</div>
				<p class="ft14">
					①：其余平台基础功能见<span class="onTrial" @click="goTrial"
						>IOT物联网平台报价明细</span
					>。
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
import { useRouter } from 'vue-router'
export default {
	components: {},
	setup() {
		const state = reactive({
			tableData: [
				{
					isOpen: true,
					title: '报价',
					borCol: '#0388FC',
					children: [
						{
							one: '初始购置价格',
							two: '9,000元/项目',
							three: '9,000元/项目'
						},
						{
							one: '订阅年费',
							two: '15%（第二年起）',
							three: '15%（第二年起）'
						},
						{
							one: '使用期技术支持',
							oneTitle: '（超时服务）',
							two: '300元/小时',
							three: '300元/小时'
						},
						{
							one: '培训服务',
							oneTitle: '（超次服务）',
							two: '600元/次',
							three: '600元/次'
						},
						{
							one: '短信服务',
							oneTitle: '',
							two: '0.05元/条',
							three: '0.05元/条'
						}
					]
				},
				{
					isOpen: true,
					title: '用户类型',
					borCol: '#886EFE',
					children: [
						{
							one: '',
							icon: '',
							oneTitle: '',
							two: '产业园区/集团企业',
							three: '小型项目'
						}
					]
				},
				{
					isOpen: true,
					title: '应用规模',
					borCol: '#0388FC',
					children: [
						{
							one: '初始数量',
							icon: '',
							oneTitle: '',
							two: '同已购的私有化部署版IOT物联网平台点位授权数量',
							three: '同已购的SaaS版IOT物联网平台点位授权数量'
						},
						{
							one: '扩容升级',
							icon: '',
							oneTitle: '',
							two: '同已购的私有化部署版IOT物联网平台点位授权数量',
							three: '同已购的SaaS版IOT物联网平台点位授权数量'
						},
						{
							one: '数据存储',
							icon: '',
							oneTitle: '',
							two: '本地',
							three: '同已购的SaaS版IOT物联网平台授权额度'
						}
					]
				},
				{
					isOpen: false,
					title: '平台基础功能',
					titleIcon: '①',
					borCol: '#886EFE',
					children: [
						{
							one: '合同管理',
							icon: '',
							oneTitle: '',
							two: '',
							twoIcon: 'd',
							three: '',
							threeIcon: 'd'
						}
					]
				},
				{
					isOpen: false,
					title: '能源管理',
					borCol: '#0388FC',
					children: [
						{
							one: '数据分析',
							icon: '',
							oneTitle: '',
							two: '',
							twoIcon: 'd',
							three: '',
							threeIcon: 'd'
						},
						{
							one: '能耗统计',
							icon: '',
							oneTitle: '',
							two: '',
							twoIcon: 'd',
							three: '',
							threeIcon: 'd'
						},
						{
							one: '仪表管理',
							icon: '',
							oneTitle: '',
							two: '',
							twoIcon: 'd',
							three: '',
							threeIcon: 'd'
						},
						{
							one: '仪表抄表',
							icon: '',
							oneTitle: '',
							two: '',
							twoIcon: 'd',
							three: '',
							threeIcon: 'd'
						},
						{
							one: '限额管理',
							icon: '',
							oneTitle: '',
							two: '',
							twoIcon: 'd',
							three: '',
							threeIcon: 'd'
						}
					]
				},
				{
					isOpen: false,
					title: '软件部署',
					borCol: '#886EFE',
					children: [
						{
							one: '部署模式',
							icon: '',
							oneTitle: '',
							two: '同已购的私有化部署版IOT物联网平台部署模式',
							twoIcon: '',
							three: '公有云',
							threeIcon: ''
						},
						{
							one: '数据接入及交钥匙服务',
							icon: '',
							oneTitle: '',
							two: '联系销售',
							twoIcon: '',
							three: '联系销售',
							threeIcon: ''
						}
					]
				},
				{
					isOpen: false,
					title: '售后支持',
					borCol: '#0388FC',
					children: [
						{
							one: '呼叫响应',
							icon: '',
							oneTitle: '',
							two: '同已购的私有化部署版IOT物联网平台响应要求',
							twoIcon: '',
							three: '5*8小时',
							threeIcon: ''
						},
						{
							one: '技术支持',
							icon: '',
							oneTitle: '',
							two: '2小时',
							twoIcon: '',
							three: '2小时',
							threeIcon: ''
						},
						{
							one: '培训支持',
							icon: '',
							oneTitle: '',
							two: '1次免费在线培训',
							twoIcon: '',
							three: '1次免费在线培训',
							threeIcon: ''
						},
						{
							one: '产品升级',
							icon: '',
							oneTitle: '',
							two: '订阅期内免费升级',
							twoIcon: '',
							three: '订阅期内免费升级',
							threeIcon: ''
						},
						{
							one: '数据备份',
							icon: '',
							oneTitle: '',
							two: '',
							twoIcon: 'c',
							three: '数据备份、导出，无供应商锁定',
							threeIcon: ''
						}
					]
				},
				{
					isOpen: false,
					title: '开发支持',
					borCol: '#886EFE',
					children: [
						{
							one: '论坛支持',
							icon: '',
							oneTitle: '',
							two: '',
							twoIcon: 'd',
							three: '',
							threeIcon: 'd'
						},
						{
							one: '邮件支持',
							icon: '',
							oneTitle: '',
							two: '',
							twoIcon: 'd',
							three: '',
							threeIcon: 'd'
						},
						{
							one: '电话支持',
							icon: '',
							oneTitle: '',
							two: '5*8小时',
							twoIcon: '',
							three: '5*8小时',
							threeIcon: ''
						},
						{
							one: '企业微信',
							icon: '',
							oneTitle: '',
							two: '',
							twoIcon: 'd',
							three: '',
							threeIcon: 'd'
						},
						{
							one: '二次开发',
							icon: '',
							oneTitle: '',
							two: '联系销售',
							twoIcon: '',
							three: '',
							threeIcon: 'c'
						}
					]
				}
			],
			allOpen: computed(() =>
				state.tableData.every((item) => item.isOpen)
			)
		})
		const allCheck = () => {
			let bool = !state.allOpen
			state.tableData.forEach((item, i) => {
				if (i > 2) {
					item.isOpen = bool
				}
			})
		}
		// 切换显示隐藏
		const toggleHide = (row) => {
			row.isOpen = !row.isOpen
		}
		const router = useRouter()
		const goTrial = () => {
			router.push('/price/iot')
		}
		return {
			...toRefs(state),
			goTrial,
			toggleHide,
			allCheck
		}
	}
}
</script>

<style scoped lang="scss">
.drrowRight {
	cursor: pointer;
	transform: rotate(90deg);
	position: relative;
	top: 2px;
	font-size: 16px;
	margin-left: 3px;
}
.upIcon {
	transform: rotate(-90deg);
}
.banner {
	background-image: url(../../assets/bc/19.png);
}
.ft16 {
	font-size: 16px;
}
.ft14 {
	font-size: 14px;
}
.bold {
	font-weight: 700;
}
.flex {
	display: flex;
}
.flexw {
	flex-wrap: wrap;
}
.mb10 {
	margin-bottom: 10px;
}
.mt10 {
	margin-top: 10px;
}
.mr3 {
	margin-right: 3px;
}
.mb3 {
	margin-bottom: 3px;
}
.w160 {
	// width: 200px !important;
	width: 20% !important;
}
.rightTitle {
	width: calc(100% - 15% - 3px);
}
.energy-price {
	display: flex;
	justify-content: center;
	width: 100%;
	background-color: #f5f5f5;
	padding-bottom: 50px;
	.whole-table {
		width: 100%;
		padding: 0 50px;
	}
	.row-one {
		padding-left: 15px;
		box-sizing: border-box;
	}
	.row-three {
		padding-left: 15px;
		box-sizing: border-box;
	}
	.w200 {
		// width: 200px;
		width: 15%;
	}
	.w400 {
		// width: 425px;
		width: calc((100% - 20%) / 2);
	}
	.wAll {
		width: calc(100% - 15% - 3px);
		.row-two {
			margin-bottom: 3px;
			&:nth-last-child(1) {
				margin-bottom: 0;
			}
			.w400 {
				&:nth-last-child(1) {
					margin-right: 0;
				}
			}
		}
	}
	.row-two {
		.row-one {
			padding: 20px;
			box-sizing: border-box;
		}
	}
	.bgcf {
		background-color: #fff;
	}
	.circular {
		display: inline-block;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background-color: #0388fc;
		position: relative;
		top: -1px;
	}
	.opac {
		opacity: 0;
	}
	.leftTitle {
		padding: 6px;
		box-sizing: border-box;
		.title-text {
			display: flex;
			justify-content: center;
			align-items: center;
			border-left: 2px solid #0388fc;
			height: 100%;
		}
	}
	.borLeft {
		border-left-color: #886efe !important;
	}
	.onTrial {
		cursor: pointer;
		color: #0388fc;
	}
	.hideClass {
		width: 100%;
		background-color: #fff;
		padding: 20px;
		text-align: center;
	}
}
</style>
